export default __webpack_public_path__ + "static/media/foundation.c3763af0.png";